import { c as _c } from "react/compiler-runtime";
import { ProjectLaunchTarget } from "@custom-types/sdb-company-types";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { NotFoundPage } from "@pages/not-found-page";
import { useAppParams } from "@router/router-helper";
import { appStateSelector } from "@store/app/app-selector";
import { useAppSelector } from "@store/store-helper";
import { trackOpenProject } from "@utils/project-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { getBooleanQueryParam } from "@utils/url-utils";
import { useEffect } from "react";

/**
 * Redirects to the Viewer's Data Management editor if the project ID is defined.
 * Otherwise it shows an error page.
 * This redirect is necessary because some users may still have deep links to the Dashboard's
 * removed Data Management editor.
 */
export function DataManagement() {
  const $ = _c(12);
  const {
    trackAsyncEvent
  } = useTrackEvent();
  const {
    navigateToDataManagement
  } = useAppNavigation();
  const {
    projectId
  } = useAppParams();
  const {
    isDevModeEnabled,
    isAlphaTestingEnabled,
    isBetaTestingEnabled
  } = useAppSelector(appStateSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getBooleanQueryParam(globalThis.location.search, "importFromViewer") || getBooleanQueryParam(globalThis.location.search, "showUpload");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const shouldShowUpload = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getBooleanQueryParam(globalThis.location.search, "publishPanel") || getBooleanQueryParam(globalThis.location.search, "showPublish");
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldShowPublish = t1;
  let t2;
  let t3;
  if ($[2] !== isAlphaTestingEnabled || $[3] !== isBetaTestingEnabled || $[4] !== isDevModeEnabled || $[5] !== navigateToDataManagement || $[6] !== projectId || $[7] !== trackAsyncEvent) {
    t2 = () => {
      if (projectId) {
        trackOpenProject({
          openFrom: "dataManagement-redirect",
          numberOfMembers: undefined,
          openTarget: ProjectLaunchTarget.sphereViewer,
          trackAsyncEvent
        });
        navigateToDataManagement({
          projectId,
          shouldEnableDev: isDevModeEnabled,
          shouldEnableAlpha: isAlphaTestingEnabled,
          shouldEnableBeta: isBetaTestingEnabled,
          shouldShowUpload,
          shouldShowPublish
        });
      }
    };
    t3 = [isAlphaTestingEnabled, isBetaTestingEnabled, isDevModeEnabled, navigateToDataManagement, projectId, shouldShowPublish, shouldShowUpload, trackAsyncEvent];
    $[2] = isAlphaTestingEnabled;
    $[3] = isBetaTestingEnabled;
    $[4] = isDevModeEnabled;
    $[5] = navigateToDataManagement;
    $[6] = projectId;
    $[7] = trackAsyncEvent;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  if (!projectId) {
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <NotFoundPage />;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div> </div>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}